module.exports = __webpack_public_path__ + "static/stend4-f54d00c9a3995565cb2e183235253730.jpg";